import { render } from "./Video.vue?vue&type=template&id=1d58ef24"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d58ef24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d58ef24', __exports__)) {
    api.reload('1d58ef24', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=1d58ef24", () => {
    api.rerender('1d58ef24', render)
  })

}


export default __exports__